import React from 'react'
import { FormControl, FormGroup, FormControlLabel, Checkbox } from '@material-ui/core'

type Options = { checked: boolean; label: string; value: any }[]
type CheckboxesProps = {
  options: Options
  chekedHandler: (checked: Options) => void
}
const Checkboxes: React.FC<CheckboxesProps> = props => {
  const { options, chekedHandler } = props
  return (
    <FormControl component="fieldset">
      <FormGroup aria-label="position" row>
        {options.map(option => (
          <FormControlLabel
            key={option.value}
            value="top"
            control={
              <Checkbox
                checked={option.checked}
                onChange={() => {
                  chekedHandler(
                    options.map(o => {
                      if (o.value === option.value) {
                        return { checked: !o.checked, label: o.label, value: o.value }
                      } else {
                        return o
                      }
                    })
                  )
                }}
              />
            }
            label={option.label}
            labelPlacement="end"
          />
        ))}
      </FormGroup>
    </FormControl>
  )
}

export default Checkboxes
